<template>
  <div class="input">
    <div class="input-label">イベント内容</div>
    <div class="input-group">
      <textarea
        rows="3"
        class="input-textarea"
        v-model="content"
        disabled
        >
      </textarea>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    content: {
      get: function () {
        return this.$store.state.eventClosed.content
      },
      set: function (value) {
        this.$store.commit(
          'eventClosed/setContent',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
